/**
 * Styles aligned with Figma "Export Plan" modal (507:25942).
 */
const exportPlanModalStyles = () => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    maxHeight: '60vh',
    overflowY: 'auto',
  },
  sectionsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  sectionsLabel: {
    color: 'var(--grey-90, #707070)',
    margin: 0,
    textTransform: 'uppercase',
  },
  selectAllButton: {
    color: 'var(--primary-main, #0f48b8)',
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: '0.32px',
    textTransform: 'none',
    padding: '6px 20px',
    minHeight: 40,
  },
  sectionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  sectionCard: {
    border: '1px solid var(--grey-50, #dbe0e8)',
    borderRadius: 16,
    backgroundColor: 'var(--white, #ffffff)',
    width: '100%',
    boxSizing: 'border-box',
  },
  sectionCardSelected: {
    border: '1px solid var(--primary-main, #0f48b8)',
    backgroundColor: 'var(--primary-pale, #f0f6ff)',
  },
  sectionCardRow: {
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
    padding: '12px 12px 8px',
  },
  checkbox: {
    padding: 0,
    marginTop: 2,
    color: 'var(--primary-main, #0f48b8)',
    '&.Mui-checked': {
      color: 'var(--primary-main, #0f48b8)',
    },
  },
  sectionTitle: {
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.32px',
    color: 'var(--navy-main, #061e44)',
    margin: 0,
  },
  sectionDescription: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#49454f',
    margin: '12px 0 0',
  },
  widgetList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px 4px',
    padding: '0 12px 12px 48px',
    fontFamily: '"Inter", sans-serif',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.32px',
    color: 'var(--grey-110, #333333)',
  },
  widgetName: {
    whiteSpace: 'nowrap',
  },
  infoNote: {
    display: 'flex',
    gap: 8,
    alignItems: 'flex-start',
    padding: '0 24px',
    width: '100%',
    boxSizing: 'border-box',
  },
  infoIcon: {
    fontSize: 16,
    color: 'var(--grey-100, #4f5154)',
    marginTop: 2,
  },
  infoText: {
    fontFamily: '"Inter", sans-serif',
    fontStyle: 'italic',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: '0.28px',
    color: 'var(--grey-100, #4f5154)',
    margin: 0,
  },
});

export default exportPlanModalStyles;

export const ExportPlanModalStyles = () => ({
  '& .modal-footer div': {
    flexFlow: 'row-reverse',
    gap: 10,
  },
});
